import { createEffect, createSignal, Show } from "solid-js";
import {
  AlertDialog,
  AlertDialogClose,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/shadcn/alert-dialog";
import { TextFieldRoot, TextFieldLabel, TextField } from "@/components/shadcn/textfield";
import { Button } from "@/components/shadcn/button";

import { request } from "../../requests/request";

export const Confirmer = (props) => {

  const [show, setShow] = createSignal(false);
  const [state, setState] = createSignal(0);
  const [text, setText] = createSignal("");
  const [type, setType] = createSignal("");
  const [title, setTitle] = createSignal("");
  const [message, setMessage] = createSignal("");
  const [confirm, setConfirm] = createSignal(props.confirm || false);

  createEffect(() => {
    props.show;
    setShow(props.show);
    setConfirm(props.confirm);
  });

  createEffect(() => {
    props.confirm;
    setConfirm(props.confirm);
  });

  const onHandle = (ev) => {
    setText(ev.target.value);
  }

  const closeModal = () => {
    setState(0);
    setMessage("");
    setTitle("");
    setType("");
    setConfirm(false);
    props.onClose();
  }

  const onValidate = async () => {
    setState(1);
    const form = {
      data: props.data,
      text: props.text,
      value: text(),
    };

    try {
      const response = await request(props.url, form);

      setMessage(response.message);
      setTitle(response.title);
      setType(response.type);

      if (type() === 'success' && typeof (props.callback) === 'function') {
        props.callback();
      }
    } catch (error) {
      setMessage(error);
      setTitle("Error");
      setType("error");
    } finally {
      setText("");
      setState(2);
    }
  }

  return (
    <AlertDialog open={show()}>
      <AlertDialogContent class={state() === 1 ? "max-w-[250px]" : ""} onClose={props.onClose} hideOnOutsideClick={false}>
        <AlertDialogHeader>
          <div class="flex justify-center">
            <Show when={state() === 0}>
              <svg width="100" height="100" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                <circle cx="50" cy="50" r="45" fill="none" stroke="#FFA500" stroke-width="4" />
                <line x1="50" y1="30" x2="50" y2="60" stroke="#FFA500" stroke-width="4" stroke-linecap="round">
                  <animate attributeName="opacity" values="1;0;1" dur="1s" repeatCount="indefinite" />
                </line>
                <circle cx="50" cy="70" r="4" fill="#FFA500">
                  <animate attributeName="opacity" values="1;0;1" dur="1s" repeatCount="indefinite" />
                </circle>
              </svg>
            </Show>
            <Show when={state() === 2 && type() === 'info'}>
              <svg width="100" height="100" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                <circle cx="50" cy="50" r="45" fill="none" stroke="#17A2B8" stroke-width="4" />
                <line x1="50" y1="30" x2="50" y2="50" stroke="#17A2B8" stroke-width="4" stroke-linecap="round" />
                <circle cx="50" cy="65" r="4" fill="#17A2B8" />
                <circle cx="50" cy="50" r="40" fill="none" stroke="#17A2B8" stroke-width="2" stroke-dasharray="150,150">
                  <animateTransform attributeName="transform" type="rotate" from="0 50 50" to="360 50 50" dur="2s" repeatCount="indefinite" />
                </circle>
              </svg>
            </Show>
            <Show when={state() === 2 && type() === 'warning'}>
              <svg width="100" height="100" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                <polygon points="50,10 90,80 10,80" fill="none" stroke="#FFC107" stroke-width="4" />
                <line x1="50" y1="35" x2="50" y2="55" stroke="#FFC107" stroke-width="4" stroke-linecap="round">
                  <animate attributeName="opacity" values="1;0;1" dur="1s" repeatCount="indefinite" />
                </line>
                <circle cx="50" cy="70" r="4" fill="#FFC107">
                  <animate attributeName="opacity" values="1;0;1" dur="1s" repeatCount="indefinite" />
                </circle>
              </svg>
            </Show>
            <Show when={state() === 2 && type() === 'success'}>
              <svg width="100" height="100" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                <circle cx="50" cy="50" r="45" fill="none" stroke="#28A745" stroke-width="4" />
                <path d="M30 50 L45 65 L70 35" fill="none" stroke="#28A745" stroke-width="4" stroke-linecap="round" stroke-linejoin="round">
                  <animate attributeName="stroke-dasharray" from="0,100" to="100,0" dur="0.5s" fill="freeze" />
                </path>
              </svg>
            </Show>
            <Show when={state() === 2 && type() === 'error'}>
              <svg width="100" height="100" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                <circle cx="50" cy="50" r="45" fill="none" stroke="#DC3545" stroke-width="4" />
                <line x1="35" y1="35" x2="65" y2="65" stroke="#DC3545" stroke-width="4" stroke-linecap="round">
                  <animate attributeName="stroke-dasharray" from="0,100" to="100,0" dur="0.5s" fill="freeze" />
                </line>
                <line x1="65" y1="35" x2="35" y2="65" stroke="#DC3545" stroke-width="4" stroke-linecap="round">
                  <animate attributeName="stroke-dasharray" from="0,100" to="100,0" dur="0.5s" fill="freeze" />
                </line>
              </svg>
            </Show>
            <Show when={state() === 1}>
              <svg width="100" height="100" stroke="#000" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <g class="spinner_V8m1"><circle cx="12" cy="12" r="9.5" fill="none" stroke-width="1"></circle></g>
              </svg>
            </Show>
          </div>
          <Show when={state() !== 1}>
            <AlertDialogTitle class="text-center">{state() === 2 ? title() : props.title}</AlertDialogTitle>
            <AlertDialogDescription class="text-center">{state() === 2 ? message() : props.message}</AlertDialogDescription>
          </Show>
        </AlertDialogHeader>
        <Show when={state() === 0 && confirm()}>
          <div class="flex justify-center mb-3">
          <TextFieldRoot class="w-[300px]">
            <TextFieldLabel class="text-center w-full block">Type "{props.text}" to Confirm</TextFieldLabel>
            <TextField
              class="mt-[0px]"
              type={'text'}
              autoCapitalize="none"
              autocorrect="off"
              value={text()}
              onChange={onHandle}
            />
          </TextFieldRoot>
          </div>
        </Show>
        <Show when={state() !== 1}>
          <AlertDialogFooter class="flex justify-center items-center flex-row sm:justify-center">
            <Show when={state() === 2}>
              <Button onClick={() => { closeModal() }}>OK</Button>
            </Show>
            <Show when={state() === 0}>
              <Button variant="outline" onClick={() => { closeModal() }}>Cancel</Button>
              <Button onClick={() => { onValidate() }}>{props.button}</Button>
            </Show>
          </AlertDialogFooter>
        </Show>
      </AlertDialogContent>
    </AlertDialog>
  );
}
